import { Box, Typography } from '@mui/material';
import { COLORS } from '../utils/constants';
import SecurityIcon from '@mui/icons-material/Security';
import CheckIcon from '@mui/icons-material/Check';
import { Grid, Paper, Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from '@/kit/useTranslation';

/**
 * Safety guidelines display component
 */
export default function SafetyGuidelines({ isDesktop }) {
  const { t } = useTranslation();
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: `${COLORS.accent}05`,
        border: `1px solid ${COLORS.accent}30`,
        position: 'static',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <SecurityIcon sx={{ fontSize: 20, color: COLORS.accent }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.textPrimary }}>
            {t('estimate.safety.title')}
          </Typography>
        </Box>
        <Stack spacing={1.2}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              {t('estimate.safety.tip1')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              {t('estimate.safety.tip2')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              {t('estimate.safety.tip3')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              {t('estimate.safety.tip4')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <CheckIcon
              sx={{
                fontSize: 14,
                color: COLORS.accent,
                mt: 0.3,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: COLORS.textSecondary,
                lineHeight: 1.4,
                fontSize: '0.7rem',
              }}
            >
              {t('estimate.safety.tip5')}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
}
